export enum Mode {
	Selection,
	Modification
}